import TShirt from "../../images/Tariff-t-shirt.png";

import IndusMachine from "../../images/IndusMachine.png";

// international
// 1 = 2L
// 2 = 2A
// 5 = 2b
// 6 = 2c
// 7 = 2d
// 8 = 2e
// 9 = 2f
// 10 = 2g
// 11 = 2h
// 12 = 2I
// 13 = 2j
// 14 = 2k

// tariff
// 1=A, 2=B, 3=C, 4=D, 5=E,6=F,7=G,8=H,9=I, 10=J, 11=K, 12=L, 13=M, 14=N, 15=O, 16=P

const questionAnswers = [
  // International Graph Questions
  {
    title: "U.S. T-Shirt Market",
    type: "international",
    answer: [2, 5, 6, 7, 8], //2A,2B,2C,2D,2E
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price.",
    notQuiteText:
      "Not quite. You identified part, but not all of the new total surplus from international trade.",
    answerText: "Total surplus is the sum of consumer and producer surplus.",
    header: "WITHOUT A TARIFF",
    mobileHeader: "WITHOUT A TARIFF",
    text: "The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. The world supply curve is labeled “World Supply” and the domestic supply curve is labeled “Domestic Supply” on the graph.",
    question: "TOTAL SURPLUS",
    icon: TShirt,
  },
  // (MC answer choices: a Domestic consumers, b Domestic producers, c. domestic consumer and domestic consumers, d. No One)
  {
    title: "U.S. T-Shirt Market",
    type: "international",
    answer: ["B"],
    options: ["Yes", "No"],
    alreadySelect: [],
    answerTextTop:
      "Q. When there is no tariff, does the government receive any revenue from international trade?",
    notQuiteText: "",
    answerText:
      "Since the government has not enacted a tariff, it receives no revenue from the trading between domestic consumers and foreign producers.",
    header: "",
    mobileHeader: "",
    text: "When there is no tariff, does the government receive any revenue from international trade?",
    question:
      "When there is no tariff, does the government receive any revenue from international trade?",
    icon: TShirt,
  },
  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [1, 2, 3, 4],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the domestic consumer surplus from international trade with a tariff applied.",
    answerText:
      "The area under the demand curve and above the price represents the consumer surplus. With international trade and a tariff applied, the consumer surplus shrinks to the green triangle shown (compared to free trade).",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "DOMESTIC CONSUMER SURPLUS",
    icon: TShirt,
  },
  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [5, 6, 7, 8, 9],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the decrease in domestic consumer surplus from international trade with a tariff applied.",
    answerText:
      "Consumer surplus decreases to the green area shown. This decrease is a result of the new, higher price of t-shirts.",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "DECREASE in DOMESTIC CONSUMER SURPLUS",
    icon: TShirt,
  },
  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [5, 10],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the domestic producer surplus from international trade with a tariff applied.",
    answerText:
      "The area above the supply curve and below the price represents the producer surplus. With international trade and a tariff applied, the producer surplus increases to the green triangle shown (compared to free trade).",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "DOMESTIC PRODUCER SURPLUS",
    icon: TShirt,
  },

  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [5],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the increase in domestic producer surplus from international trade with a tariff applied.",
    answerText:
      "Producer surplus increases to the green area shown. This increase is a result of the new, higher price of t-shirts.",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "INCREASE in DOMESTIC PRODUCER SURPLUS",
    icon: TShirt,
  },

  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: ["A"],
    options: ["Yes", "No"],
    alreadySelect: [],
    answerTextTop:
      "Q. Now that there is a tariff, does the government receive any revenue from international trade?",
    notQuiteText: "",
    answerText:
      "Since the government has enacted a tariff, it receives revenue from the trading between domestic consumers and foreign producers.",
    header: "",
    mobileHeader: "",
    text: "Now that there is a tariff, does the government receive any revenue from international trade?",
    question:
      "Now that there is a tariff, does the government receive any revenue from international trade?",
    icon: TShirt,
  },

  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [7, 8],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the government revenue from the tariff.",
    answerText:"The government revenue from the tariff equals the tariff amount multiplied by the quantity of imported t-shirts. The tariff amount is the distance between the supply curves “World Supply” and “World Supply + Tariff.” The quantity of imported t-shirts equals Q<sub>d</sub> - Q<sub>s</sub>. The green area shown represents the government revenue.",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "GOVERNMENT TARIFF REVENUE",
    icon: TShirt,
  },
  {
    title: "U.S. T-Shirt Market",
    type: "tariff",
    answer: [6, 9],
    answerTextTop:
      "Q. The U.S. imports t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is now levied on imported t-shirts.",
    notQuiteText:
      "Not quite. You identified part, but not all of the deadweight loss from the tariff.",
    answerText:
      "The deadweight loss is a result of lost gains from trade (due to the lower domestic consumption), and wasted resources (due to the higher but more costly domestic production) as a result of the tariff.",
    header: "WITH A TARIFF",
    mobileHeader: "WITH A TARIFF",
    text: "The U.S. is now able to import t-shirts from other countries at a lower price than the U.S. market price. However, a tariff is levied on imported t-shirts. The new price is labeled “P<sub>w</sub>+Tariff”.",
    question: "DEADWEIGHT LOSS",
    icon: TShirt,
  },
];

export default questionAnswers;
